
export const TEAL     = "#4DB8B5";
export const BOARD_BG = "#F8F6F1";

export const CANVAS_W  = 8000;
export const CANVAS_H  = 6000;
export const MIN_SCALE = 0.1;
export const MAX_SCALE = 4;

export const UNDO_LIMIT = 50;

export const GRID_MODES = ["dots", "lines", "off"];

export const MARKER_COLORS = [
  { hex: "#1E293B", label: "Black"  },
  { hex: "#4DB8B5", label: "Teal"   },
  { hex: "#3B82F6", label: "Blue"   },
  { hex: "#22C55E", label: "Green"  },
  { hex: "#F59E0B", label: "Amber"  },
  { hex: "#EF4444", label: "Red"    },
  { hex: "#A855F7", label: "Purple" },
];

export const STICKY_COLORS = ["#FEF08A", "#BBF7D0", "#BFDBFE", "#FBCFE8", "#FED7AA"];

export const CARD_TYPES = {
  decision: { color: "#22C55E", bg: "rgba(34,197,94,0.08)",  border: "#22C55E", label: "Decision", icon: "✓" },
  finding:  { color: "#3B82F6", bg: "rgba(59,130,246,0.08)", border: "#3B82F6", label: "Finding",  icon: "◆" },
  question: { color: "#F59E0B", bg: "rgba(245,158,11,0.08)", border: "#F59E0B", label: "Question", icon: "?" },
  idea:     { color: "#A855F7", bg: "rgba(168,85,247,0.08)", border: "#A855F7", label: "Idea",     icon: "★" },
};

export const uid = () => `el-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

export const toCanvas = (screenX, screenY, vp, rect) => ({
  x: (screenX - rect.left - vp.x) / vp.scale,
  y: (screenY - rect.top  - vp.y) / vp.scale,
});

export const elementBounds = (el) => {
  if (el.type === "stroke") {
    if (!el.points?.length) return null;
    const xs = el.points.map((p) => p.x);
    const ys = el.points.map((p) => p.y);
    return {
      x: Math.min(...xs), y: Math.min(...ys),
      w: Math.max(...xs) - Math.min(...xs),
      h: Math.max(...ys) - Math.min(...ys),
    };
  }
  if (!Number.isFinite(el.x) || !Number.isFinite(el.y)) return null;
  const w = el.w ?? 200;
  const h = el.h ?? 100;
  if (!Number.isFinite(w) || !Number.isFinite(h)) return null;
  return {
    x: w < 0 ? el.x + w : el.x,
    y: h < 0 ? el.y + h : el.y,
    w: Math.abs(w),
    h: Math.abs(h),
  };
};

export function anchorOnBox(box, towards) {
  const cx = box.x + box.w / 2;
  const cy = box.y + box.h / 2;
  const dx = towards.x - cx;
  const dy = towards.y - cy;
  if (!dx && !dy) return { x: cx, y: cy };

  const hw = box.w / 2;
  const hh = box.h / 2;
  const scale = Math.min(
    Math.abs(dx) > 1e-6 ? hw / Math.abs(dx) : Infinity,
    Math.abs(dy) > 1e-6 ? hh / Math.abs(dy) : Infinity
  );
  return { x: cx + dx * scale, y: cy + dy * scale };
}

const centreOf = (box) => ({ x: box.x + box.w / 2, y: box.y + box.h / 2 });

export function connectorEndpoints(el, byId) {
  const from = byId?.get?.(el.fromId);
  const to = byId?.get?.(el.toId);
  if (!from || !to) return null;
  const a = elementBounds(from);
  const b = elementBounds(to);
  if (!a || !b) return null;
  return { a: anchorOnBox(a, centreOf(b)), b: anchorOnBox(b, centreOf(a)) };
}

export function distanceToSegment(p, a, b) {
  const vx = b.x - a.x;
  const vy = b.y - a.y;
  const len2 = vx * vx + vy * vy;
  if (!len2) return Math.hypot(p.x - a.x, p.y - a.y);
  let t = ((p.x - a.x) * vx + (p.y - a.y) * vy) / len2;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(p.x - (a.x + t * vx), p.y - (a.y + t * vy));
}
